import { Modal } from "antd";
import { Trans, useTranslation } from "react-i18next";
import imgAnnoDominiWeb from "shared/assets/images/anno-domini-sem-texto.png";
import "explorer/pages/new-estagio-artista/campanhas-especiais/CampanhasEspeciais.scss";
import { isMobile } from "react-device-detect";

interface ModalCampaignADRequestProps {
  open: boolean;
  onCancel: () => void;
}

const ModalCampaignADRequest: React.FC<ModalCampaignADRequestProps> = (
  props
) => {
  const { open, onCancel } = props;
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onCancel}
      closable={true}
      maskClosable={false}
      title={null}
      className={`modal-campanha-especial modal-anno-domini ${
        isMobile ? "mobile" : "web"
      }`}
    >
      <>
        <div
          className="background"
          style={{
            background: `url(${imgAnnoDominiWeb}) no-repeat`,
            backgroundSize: "cover",
            borderRadius: "8px 8px 0 0",
            minHeight: 330,
            width: "100%",
            position: "absolute",
          }}
        />
        <div style={{ position: "relative" }}>
          <div
            className={`conteudo conteudo-anno-domini ${
              isMobile ? "mobile" : "web"
            }`}
          >
            <div
              style={{
                paddingTop: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "0 48px",
              }}
            >
              <span className="chamada">
                {t("pages.CampanhasEspeciais.AnnoDomini.curadoriaSelecao")}
              </span>
              <h1 className="titulo">
                {t(
                  "pages.CampanhasEspeciais.AnnoDomini.recebemosSoliciacaoTitulo"
                )}
              </h1>

              <span className="divider" />
            </div>

            <p
              style={{
                padding: "0 48px",
                textAlign: "center",
              }}
            >
              <Trans
                i18nKey={t(
                  "pages.CampanhasEspeciais.AnnoDomini.recebemosSoliciacaoTexto"
                )}
              />
            </p>

            <div style={{ background: "#1A1A1A", paddingTop: 12 }}>
              <ul>
                <li className="circle-checkmark azul">
                  {t("pages.CampanhasEspeciais.AnnoDomini.strmHelp1")}
                </li>
                <li className="circle-checkmark azul">
                  {t("pages.CampanhasEspeciais.AnnoDomini.strmHelp2")}
                </li>
                <li className="circle-checkmark azul">
                  {t("pages.CampanhasEspeciais.AnnoDomini.strmHelp3")}
                </li>
                <li className="circle-checkmark azul">
                  {t("pages.CampanhasEspeciais.AnnoDomini.strmHelp4")}
                </li>
              </ul>
              <div className="buttons">
                <button className="botao-roxo" onClick={onCancel}>
                  {t("pages.CampanhasEspeciais.continuarEvoluindo")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </Modal>
  );
};

export default ModalCampaignADRequest;
